// Broker Message
export const BROKER_MESSAGE_ANSWERS_TEST_ID = 'broker-message-answers';

// RFQ Details
export const RFQ_DETAILS_DYNAMIC_FORM_TEST_ID = 'rfq-details-dynamic-form';
export const RFQ_SAVE_AND_EXIT_MODAL_TEST_ID = 'rfq-save-and-exit-modal';
